import { lazy } from 'react';

import Loadable from '../components/Loadable';
import MinimalLayout from './../layout/MinimalLayout/index';
const AuthWrapper = Loadable(lazy(() => import('../pages/auth/AuthWraper')));
const LoginRoutes = {
  path: '/',
  element: <MinimalLayout />,
  children: [
    {
      path: '/login',
      element: <AuthWrapper />
    },
    {
      path: '/admin/login',
      element: <AuthWrapper />
    },
    {
      path: '/sign-up',
      element: <AuthWrapper />
    },
    {
      path: 'otp',
      element: <AuthWrapper />
    },
    {
      path: 'forget-password',
      element: <AuthWrapper />
    },
    {
      path: 'set-password',
      element: <AuthWrapper />
    }
  ]
};

export default LoginRoutes;
